



























import { Component, Vue } from 'vue-property-decorator';
import TabAccountInfo from './account-info.tab.vue';
import TabOrders from './orders.tab.vue';
import TabSupport from './support.tab.vue';

@Component({
  components: {
    TabAccountInfo,
    TabOrders,
    TabSupport,
  },
})
export default class CustomerPanelShell extends Vue {
  activeTab = 'support';
}
